import { c as _c } from "react/compiler-runtime";
/* eslint-disable @typescript-eslint/explicit-function-return-type */
// We want to use the inferred return types from Jotai
import { useAtom, useAtomValue, useSetAtom, useStore } from 'jotai';
import type { Atom, PrimitiveAtom, SetStateAction, WritableAtom } from 'jotai';

// type SetAtom<Args extends unknown[], Result> = (...args: Args) => Result;

// We need to create custom hooks that use the store due to using NextJS
export const useJotaiAtom = atom => {
  const $ = _c(2);
  const t0 = useStore();
  let t1;
  if ($[0] !== t0) {
    t1 = {
      store: t0
    };
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return useAtom(atom, t1);
};
export const useJotaiValue = atom => {
  const $ = _c(2);
  const t0 = useStore();
  let t1;
  if ($[0] !== t0) {
    t1 = {
      store: t0
    };
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return useAtomValue(atom, t1);
};
export const useSetJotaiAtom = atom => {
  const $ = _c(2);
  const t0 = useStore();
  let t1;
  if ($[0] !== t0) {
    t1 = {
      store: t0
    };
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return useSetAtom(atom, t1);
};

// TODO: resolve these types & maybe check other repos using Jotai
// export const useResetJotaiAtom = <T, U>(atom: WritableAtom<T, [typeof RESET], unknown>) => {
//   return useResetAtom(atom, {
//     store: useStore(),
//   });
// };